import Vue from 'vue'
import App from './App.vue'
import createStore from './store/createStore'
import vuetify from 'ui/vuetify'
import { render } from 'shared/smart-text'

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    smartTextEnvironment () {
      return {
        contact: this.$store?.state?.contact,
        account: this.$store?.state?.account
      }
    }
  },
  methods: {
    $renderSmartText (value = '') {
      return render(
        ((value || '') + ''),
        this.smartTextEnvironment,
        {
          timezone: this.$store?.state?.account?.settings?.timezone
        }
      )
    }
  }
})

const emitData = (data) => {
  if (window.parent?.postMessage) {
    return window.parent.postMessage({
      ...data,
      PATCH: true,
      widgetType: 'CHAT',
      widgetId: store?.state?.widget?._id || store?.state?.widgetId
    }, '*')
  }
}

let vm
let store

const init = (storeProps) => {
  store = createStore(storeProps)

  window.$lcroot = new Vue({
    store,
    vuetify,
    render: h => h(App),
    async created () {
      this.$vuetify.theme.themes.light.primary = store.getters.color
      this.$vuetify.theme.themes.dark.primary = store.getters.color
      await store.dispatch('initialize')
      await store.dispatch('getContact')
      const style = document.createElement('style')
      style.textContent = `.v-application .primary--text { color: ${store.getters.color} !important; caret-color: ${store.getters.color} !important; } a { color: ${store.getters.color} !important; }`
      document.body.appendChild(style)
    },
    mounted () {
      if (store?.state?.preview) {
        const logRocketScript = document.createElement('script')
        logRocketScript.src = 'https://cdn.lr-in-prod.com/LogRocket.min.js'
        logRocketScript.crossOrigin = 'anonymous'
        logRocketScript.addEventListener('load', () => {
          setTimeout(() => {
            const LR = window[0]?.LogRocket || window.LogRocket
            if (LR?.init) {
              LR.init(
                'ewgcty/patch-portal',
                {
                  mergeIframes: true,
                  parentDomain: 'https://app.patchretention.com'
                }
              )
              console.log('Init LogRocket In Iframe')
            }
          }, 1000)
        })
        this.$el.append(logRocketScript)
      }
    },
    methods: {
      emitData (data) {
        return emitData(data)
      },
      close () {
        this.emitData({
          action: 'CLOSE'
        })
      }
    }
  }).$mount('#app')
}

window.addEventListener('message', function (event) {
  if (event.data?.PATCH) {
    console.log('WIDGET MESSAGE', event.data)
    if (event.data.action === 'INIT' && event.data.data) {
      init(event.data.data)
    } else if (event.data.action === 'MUTATION') {
      store.commit(event.data.mutation, event.data.data)
    } else if (event.data.action === 'ACTION') {
      store.dispatch(event.data.dispatch, event.data.data)
    }
  }
})

// If it's in development mode, initialize immediately, otherwise wait for a window message event from parent frame
if (process.env.NODE_ENV === 'development' && !window.location.href.includes('noinit')) {
  init({
    state: {
      token: process.env.VUE_APP_TEXT_CHAT_DEV_AUTH_TOKEN || 'dev-526-61d9d2a6e92e360df497cad5', // Dev mode only
      widgetId: process.env.VUE_APP_TEXT_CHAT_DEV_WIDGET_ID || '5c6372feabbee86c64874e16' // ID for widget on Ben's local env.  Need to come up with a better way to make this transparent.
    }
  })
} else {
  // Tell the parent frame we're ready for the config data
  document.addEventListener('DOMContentLoaded', function () {
    if (!vm) {
      emitData({
        action: 'READY'
      })
    }
  })
}
